import { isNodeV2 } from '@vedalib/editor'
import * as R from 'ramda'

import { getParentNode } from 'components/Editor/EditorContext/selectors/block'
import { updateBlock } from 'services/Store/Project/actions'
import { setGridArea } from 'services/Store/Project/mutators/node'
import {
  getBlock,
  getDeviceMode,
  getSelectedNodeIds,
  mergeNodeStyle,
} from 'services/Store/Project/selectors'
import store from 'services/Store/store'

import { safeParseArea } from '../formControls/Area/utils'
import { isGrid } from '../guards'

export const onSwap = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const device = getDeviceMode(state)
  const selectedNodes = getSelectedNodeIds(state)
  const children = selectedNodes.map((id) => block?.schema.nodes[id]).filter(isNodeV2)
  const parent = getParentNode(selectedNodes?.[0], block)
  const parentStyles = parent ? mergeNodeStyle(parent.style, device) : null

  if (block && isGrid(parentStyles)) {
    if (children.length !== 2) {
      return
    }
    const [first, second] = children
    const firstArea = safeParseArea(
      mergeNodeStyle(
        first.style,
        device,
        first.elementId ? block.elements[first.elementId]?.type : undefined,
      ).gridArea,
    )
    const secondArea = safeParseArea(
      mergeNodeStyle(
        second.style,
        device,
        second.elementId ? block.elements[second.elementId]?.type : undefined,
      ).gridArea,
    )

    const newBlock = R.compose(
      setGridArea(first.id, device, secondArea),
      setGridArea(second.id, device, firstArea),
    )(block)
    dispatch(updateBlock({ id: block?.uuid, value: newBlock }))
  }
}
